import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "loading-icon",
  role: "img",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM5 12C5 15.8675 8.1325 19 12 19C15.8675 19 19 15.8675 19 12C19 8.1325 15.8675 5 12 5C8.1325 5 5 8.1325 5 12Z",
      fill: "#CACED5"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.14 4.93C17.33 3.12 14.83 2 12.07 2C9.31 2 6.81 3.12 5 4.93L7.11969 7.04969C8.38625 5.78312 10.1362 5 12.07 5C14.0037 5 15.7537 5.78313 17.0203 7.04969L19.14 4.93Z",
      fill: "var(--primary)"
    }, null, -1)
  ])))
}
export default { render: render }